var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { forwardRef, useEffect, } from 'react';
import { Toast } from '.';
import { Bounce } from './Transitions';
import { Direction, parseClassName, isFunction, Default } from '../utils';
import { useToastContainer } from '../hooks';
import { Container } from '../styles';
export var ToastContainer = forwardRef(function (props, ref) {
    var _a = useToastContainer(props), getToastToRender = _a.getToastToRender, containerRef = _a.containerRef, isToastActive = _a.isToastActive;
    var className = props.className, style = props.style, rtl = props.rtl;
    function getClassName(position) {
        return isFunction(className)
            ? className({
                position: position,
                rtl: rtl,
            })
            : parseClassName(className);
    }
    useEffect(function () {
        if (ref) {
            ref.current =
                containerRef.current;
        }
    }, []);
    var positions = {
        top: props.top,
        bottom: props.bottom,
    };
    return (_jsx("div", __assign({ ref: containerRef }, { children: getToastToRender(function (position, toastList) {
            var containerStyle = !toastList.length
                ? __assign(__assign({}, style), { pointerEvents: 'none' }) : __assign({}, style);
            return (_jsx(Container, __assign({ id: "".concat(Default.CSS_NAMESPACE, "_toast_manager"), "data-position": position, position: position, rtl: rtl, className: getClassName(position), style: containerStyle }, positions, { role: "region", "aria-live": "polite" }, { children: toastList.map(function (_a, i) {
                    var toastProps = _a.props;
                    return (_createElement(Toast, __assign({}, toastProps, { isIn: isToastActive(toastProps.toastId), style: __assign(__assign({}, toastProps.style), { '--nth': i + 1, '--len': toastList.length }), key: "toast-".concat(toastProps.key) })));
                }) }), "container-".concat(position)));
        }) })));
});
ToastContainer.displayName = 'ToastContainer';
ToastContainer.defaultProps = {
    position: 'top-right',
    // @ts-ignore
    transition: Bounce,
    autoClose: 5000,
    pauseOnHover: true,
    pauseOnFocusLoss: true,
    closeOnClick: true,
    draggable: true,
    draggableDirection: Direction.X,
    role: 'alert',
};
